import React, { useRef, useEffect } from 'react'

const MeasurementInput = ({
  value,
  onChange,
  name,
  placeholder = '0',
  min = 0,
  max = 999,
  step = 0.125,
  required = false,
  errorMessage = null
}) => {

  const inputId = name
  const hasError = !!errorMessage
  const inputRef = useRef(null)

  // Set custom validity on the input element to prevent form submission
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.setCustomValidity(errorMessage || '')
    }
  }, [errorMessage])

  return (
    <div className="flex flex-col items-center">
      <div className="relative">
        <input
          ref={inputRef}
          type="number"
          id={inputId}
          value={value || ''}
          onChange={(e) => onChange(e.target.value ? parseFloat(e.target.value) : null)}
          placeholder={placeholder}
          min={min}
          max={max}
          step={step}
          required={required}
          className={`w-24 ${hasError ? 'border-red-500 border-2' : ''}`}
        />
        <span className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 opacity-60 pointer-events-none">
          <i className={'fa-regular fa-ditto'}></i>
        </span>
      </div>
      {hasError && (
        <div className="text-sm text-danger mt-1 font-semibold">
          {errorMessage}
        </div>
      )}
    </div>
  )
}

export default MeasurementInput
